import * as React   from 'react';
import { Props }    from './types'
import './styles.scss';

export const Title = (props: Props) => {
  const {
    title,
    subtitle,
    color
  } = props

  return (
    <div className="wrapperTitle">
      <h2 className={`title ${color || 'black'}`}>{title}</h2>
      <h3 className={`subtitle ${color || 'black'}`}>{subtitle}</h3>
    </div>
  )
}
